export default "__VITE_ASSET__BQW2nn7g__"